import { IconButton, MenuItem } from '@material-ui/core'
import React, { useState } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { S05, Text } from '../../../../../../../../../Styles/typography'
import { MenuEl, RegisteredTabEl } from '../Elements'
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Button from '../../../../../../../../../Components/Buttons/Button'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import BatchTimingsStore from '../../../Stores/BatchTimingsStore'
import Avatar from '../../../../../../../../../Components/Avatar'

function RegisteredTab({ data: { id, name, cover, chatId, isPaid } }) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)

  const { userType, deleteRegistration } = BatchTimingsStore.useContainer()

  return (
    <RegisteredTabEl>
      <div className='info'>
        <Avatar
          image={cover}
          name={name}
          size={3}
          variant='rounded'
          className={'avatar'}
        />
        <div className='info-details'>
          <Text>{name}</Text>
          {userType === 'teacher' && !isPaid && (
            <S05 className='error'>
              <ErrorOutlineIcon /> Fee payment due
            </S05>
          )}
        </div>
      </div>
      {userType === 'teacher' && (
        <>
          <Link to={`/dashboard/messages/${chatId}`}>
            <IconButton>
              <ChatBubbleOutlineIcon />
            </IconButton>
          </Link>
          <IconButton onClick={(e) => setMenuAnchorEl(e.currentTarget)}>
            <MoreVertIcon />
          </IconButton>
          <MenuEl
            anchorEl={menuAnchorEl}
            keepMounted
            open={Boolean(menuAnchorEl)}
            onClose={() => setMenuAnchorEl(null)}
          >
            <MenuItem>
              <Button
                type={'border'}
                name={'Deregister'}
                onClick={async () => {
                  await deleteRegistration(id)
                  setMenuAnchorEl(null)
                }}
                withConfirmation
              />
            </MenuItem>
          </MenuEl>
        </>
      )}
    </RegisteredTabEl>
  )
}

export default withRouter(RegisteredTab)
